import * as React from 'react';
import ImageList from '@mui/material/ImageList';
import ImageListItem from '@mui/material/ImageListItem';

import BH1 from "../media/Activities/Brotherhood/BH1.jpg"
import BH2 from "../media/Activities/Brotherhood/BH2.jpg"
import BH3 from "../media/Activities/Brotherhood/BH3.jpg"
import BH4 from "../media/Activities/Brotherhood/BH4.jpg"
import BH5 from "../media/Activities/Brotherhood/BH5.jpg"
import BH6 from "../media/Activities/Brotherhood/BH6.jpg"
import BH7 from "../media/Activities/Brotherhood/BH7.jpg"
import BH8 from "../media/Activities/Brotherhood/BH8.jpg"
import BH9 from "../media/Activities/Brotherhood/BH9.jpg"


export default function BrotherGallery() {
  return (
    <ImageList sx={{ width: 500, height: 517 }} cols={3} rowHeight={164}>
      {itemData.map((item) => (
        <ImageListItem key={item.img}>
          <img
            srBHet={`${item.img}?w=164&h=164&fit=crop&auto=format&dpr=2 2x`}
            src={`${item.img}?w=164&h=164&fit=crop&auto=format`}
            alt={item.title}
            loading="lazy"
          />
        </ImageListItem>
      ))}
    </ImageList>
  );
}

const itemData = [
  {
    img: BH1,
    title: 'BH1',
  },
  {
    img: BH2,
    title: 'BH2',
  },
  {
    img: BH3,
    title: 'BH3',
  },
  {
    img: BH4,
    title: 'BH4',
  },
  {
    img: BH5,
    title: 'BH5',
  },
  {
    img: BH6,
    title: 'BH6',
  },
  {
    img: BH7,
    title: 'BH7',
  },
  {
    img: BH8,
    title: 'BH8',
  },
  {
    img: BH9,
    title: 'BH9',
  },
];